import { INIT_SUCCESS_OFFLINE, INIT_SUCCESS_ONLINE, APP_OFFLINE, APP_ONLINE } from './initDucks';

// Reducer is not located in Ducks file to avoid cyclic dependencies in bootstrap.js file

const initialAppState = {
  initialized: false,
  offline: false,
};

// REDUCER
export default (state = initialAppState, action) => {
  switch (action.type) {
    case INIT_SUCCESS_ONLINE: {
      return {
        ...state,
        offline: action.payload.offline,
        initialized: true,
      };
    }
    case INIT_SUCCESS_OFFLINE: {
      return {
        ...state,
        offline: action.payload.offline,
        initialized: true,
      };
    }
    case APP_OFFLINE: {
      return {
        ...state,
        offline: true,
      };
    }
    case APP_ONLINE: {
      return {
        ...state,
        offline: false,
      };
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./book/src/commons/initializers/initReducer.js